(function () {
    'use strict';
    var m = angular.module('app');
    m.provider('resolverManager', function () {
        this.featureResolver = [
            'feature',
            function (feature) {
                return feature.init(true);
            }
        ];
        this.userNotExist = [
            '$q',
            'avananUserDao',
            function ($q, avananUserDao) {
                var deferred = $q.defer();
                avananUserDao.current().then(function () {
                    deferred.reject();
                }, function () {
                    deferred.resolve();
                });
                return deferred.promise;
            }
        ];
        this.currentUser = [
            '$q',
            'avananUserDao',
            'sideMenuManager',
            'idleManager',
            'autologinHelper',
            'feature',
            'wizardHelper',
            'modulesManager',
            'modals',
            'configDao',
            'jira',
            'brandInfo',
            'routeHelper',
            '$rootScope',
            'rolesManager',
            'licensesManager',
            '$timeout',
            'iframeMessagingService',
            '$cookies',
            function ($q, avananUserDao, sideMenuManager, idleManager, autologinHelper, feature, wizardHelper, modulesManager, modals, configDao, jira, brandInfo, routeHelper, $rootScope, rolesManager, licensesManager, $timeout, iframeMessagingService, $cookies) {
                var deferred = $q.defer();
                var maxRetryCount = 3;
                //checking it's reloading by new version
                if (window.localStorage.getItem('reloadByNewVersion')) {
                    console.log('Reloading by New Version...');
                    autologinHelper.enabled(true);
                    autologinHelper.isLoggedIn(true);
                    window.localStorage.removeItem('reloadByNewVersion');
                }
                // prepare all required data before page loaded
                function initialization(isAutologin, response) {
                    try {
                        $rootScope.userRole = response.data.role;
                        rolesManager.userRole = response.data.role;
                        licensesManager.init();
                        brandInfo.init();
                        jira.init();
                        var forceCallFeatureAPI = false;
                        if ($rootScope.prevSession !== $cookies.get('session')) {
                            forceCallFeatureAPI = true;
                            $rootScope.prevSession = $cookies.get('session');
                        }
                        feature.init(false, false, forceCallFeatureAPI).then(function () {
                            modulesManager.refreshStates();
                            wizardHelper.init();
                        });
                        sideMenuManager.currentUser(response.data);
                        if (isAutologin) {
                            autologinHelper.isLoggedIn(true);
                        }
                        if (!isAutologin && !sideMenuManager.limitedLicense()) {
                            configDao.param('limited_license').then(function (res) {
                                if (res) {
                                    sideMenuManager.limitedLicense(true);
                                }
                            });
                        }
                        idleManager.init().then(function () {
                            $rootScope.pageVisitCount++;
                            deferred.resolve(response);
                        });
                        if (autologinHelper.decodedRoute()) {
                            window.location.href = autologinHelper.decodedRoute();
                            autologinHelper.decodedRoute(true);
                        }
                    } catch (e) {
                        console.log('Exception error on processing resolver', e);
                        deferred.reject(e);
                    }
                }
                // check current_user api for authentication
                var retryCountForCurrentUser = 0;
                function checkCurrentUser(isAutologin) {
                    sideMenuManager.versionRecheck();
                    avananUserDao.current().then(function (res) {
                        initialization(isAutologin, res);
                    }).catch(function (err) {
                        if (isAutologin) {
                            console.log('Fail current_user api after autologin success');
                        } else {
                            console.log('Fail current_user api on loading page');
                        }
                        // retry 10 times if failed.
                        if (retryCountForCurrentUser < maxRetryCount && (isAutologin || $rootScope.pageVisitCount)) {
                            retryCountForCurrentUser++;
                            $timeout(function () {
                                checkCurrentUser(isAutologin);
                            }, 500);
                        } else {
                            retryCountForCurrentUser = 0;
                            $rootScope.doLogout = true;
                            deferred.reject(err);
                        }
                    });
                }
                // try autologin for portal
                function tryAutologin() {
                    avananUserDao.autologin(autologinHelper.first_time_token(), autologinHelper.serialNumber()).then(function () {
                        checkCurrentUser(true);
                    }, function (error) {
                        console.log('Fail autologin api');
                        $rootScope.doLogout = true;
                        deferred.reject(error);
                    });
                }
                if (autologinHelper.enabled() && !autologinHelper.isLoggedIn()) {
                    tryAutologin();
                } else {
                    checkCurrentUser(false);
                }
                return deferred.promise;
            }
        ];
        this.$get = [];
    });
}());